import { SWRFetcher } from '@commenda/utils';
import {
  BusinessEntity,
  MarketplaceProduct,
  MarketplaceProductByVendor,
  Prisma,
} from '@prisma/client';
import useSWR, { KeyedMutator } from 'swr';

interface MarketplaceServiceRequestProps {
  caFirmId?: string;
  companyId?: number;
}

export type TMarketplaceServiceRequest =
  Prisma.MarketplaceServiceRequestGetPayload<{
    include: {
      productByVendorVariant: {
        include: {
          productByVendor: {
            select: {
              product: {
                select: {
                  title: true;
                };
              };
            };
          };
          productPricingVariant: true;
        };
      };
      corporation: true;
    };
  }> & {
    marketplaceServiceProvidedByFirm: MarketplaceProductByVendor & {
      marketplaceServiceOffering: MarketplaceProduct;
    };
    corporation: BusinessEntity;
  };

export function useMarketplaceServiceRequest({
  caFirmId,
  companyId,
}: MarketplaceServiceRequestProps): {
  data?: TMarketplaceServiceRequest[];
  error?: unknown;
  mutate: KeyedMutator<any>;
} {
  const queryParam = caFirmId
    ? `caFirmId=${caFirmId}`
    : companyId
      ? `companyId=${companyId}`
      : null;

  const { data, error, mutate } = useSWR<TMarketplaceServiceRequest[]>(
    queryParam ? `marketplace/service-requests?${queryParam}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, mutate };
}
